module.exports = __webpack_public_path__ + "img/lg.eaed384b.png";